// extracted by mini-css-extract-plugin
export var primary = "Button-module--primary--LhfXg";
export var accent = "Button-module--accent--ZvGLJ";
export var neutral = "Button-module--neutral--XPdpb";